// ※サーバから返ってきている情報を使っている項目で、ページに反映されないデータもあるので注意
const imgPath = '/static/img/yearluck/y2023/'
const dirKey = 'suishotamako'

const info = {
  name: '水晶玉子',
  itemId: 6408,
  lpId: 0, //なければ0
  pkgTitle: '暮れの酉の2022年のあなたの運勢あああああああああああああああ',
  price: 999,
  memberPrice: 500,
  pkgDescription: 'パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。',
  pkgNotice: '※この商品は、占いサイト『水晶玉子のオリエンタル占星術』の「2023年上半期の全運勢」の一部と同じ内容のものになります。',
}

const top = {
  thumbnail: `${imgPath}top/counselor/${dirKey}/top_thumnail.png`,
  pkgTitleImg: `${imgPath}top/counselor/${dirKey}/top_pkg_title_img.png`,
  pkgBackImg: `${imgPath}top/counselor/${dirKey}/top_bg.png`,
}

const input = {
  thumbnail: `${imgPath}input/counselor/${dirKey}/input_thumnail.png`,
  fukiImage: `${imgPath}input/counselor/${dirKey}/input_fuki.png`,
  pkgBackImg: `${imgPath}input/counselor/${dirKey}/bg_topinfo.png`,
  headInfoBgUpp: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_upper.png`,
  headInfoBgMdl: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_middle.png`,
}

const result = {
  title: '水晶玉子が占う！<br>2023年上半期の全運勢',
  thumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  underThumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  description: '鑑定に来てくださって、ありがとうございます。恋に仕事に…日々をがんばるあなたを幸せに導くために。2023年上半期の運勢を、これからくわしく占っていきましょう。',
  bottomFukiMessage: '鑑定はいかがでしたか？　あなたの新しい1年が、幸せあふれる1年になりますように。',
}

export default {
  info,
  top,
  input,
  result,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2023/data/counselor/pkg08_suisho_tamako.js